import _ from 'lodash';
import { tips, formatTime } from '@/scripts/tools/utils';
import async from '@/scripts/tools/async';
import eventProxy from '@/scripts/tools/eventProxy';
import dialog from '@/scripts/tools/dialog';
import cos from '@/scripts/helper/cos';
import fileDeleter from '@/scripts/helper/fileDeleter';
// import dialog from '@utils/dialog';
import { sliceCopyFile, checkSameMetaAndAclList, checkIfHasGetObjectAcl } from '@/scripts/helper/cos/cosSdkUtils';
import { store } from '@/scripts/store';

const { lang } = window;

const checkData = {
  // 检查复制行为是否非法
  isCopyForbidden(params) {
    const { source, target } = params;

    // 检测源和目标地域是否存在隔离
    if (store.IsQCloudCos && this.isRegionUnreachable(source, target)) {
      return 'region_unreachable_between_fsi_public';
    }

    // 检测源和目标存储桶在多 AZ 属性上是否存在隔离
    if (store.IsQCloudCos && this.isMazUnreachable(source, target)) {
      return 'no_support_copy_MAZ_OAZ';
    }

    // 检测是否存在递归复制，即将 父目录 复制到 子目录 下
    if (this.isRecursiveCopy(source, target)) {
      return 'no_support_between_parent_dir_and_sub';
    }

    // 判断是否原地复制，即点击了 复制，不切换目录，直接点击粘贴
    if (!target.allowSituCopy && this.isSituCopy(source, target)) {
      return 'not_allow_paste_in_origin';
    }

    return false;
  },

  // 检测源和目标地域是否存在隔离
  isRegionUnreachable(source, target) {
    if (!source.Region && !target.Region) return false;
    const sourceIsFsi = source.Region.indexOf('-fsi') > -1;
    const targetIsFsi = target.Region.indexOf('-fsi') > -1;
    return sourceIsFsi !== targetIsFsi;
  },

  // 检测源和目标存储桶在多 AZ 属性上是否存在隔离
  isMazUnreachable(source, target) {
    const sourceIsMaz = source.Maz;
    const targetIsMaz = target.Maz;
    return sourceIsMaz !== targetIsMaz;
  },

  // 检测是否存在递归复制，即将 父目录 复制到 子目录 下
  isRecursiveCopy(source, target) {
    const self = this;

    return _.reduce(
      source.files,
      (res, item) => {
        const { Bucket, Region, Prefix } = source;
        const sourceItem = {
          Bucket,
          Region,
          Prefix,
          Key: item.key,
          isDir: item.isDir,
        };
        return res || self.isParentDir(sourceItem, target);
      },
      false,
    );
  },

  // 判断是否原地复制，即点击了 复制，不切换目录，直接点击粘贴
  isSituCopy(source, target) {
    const self = this;

    return _.reduce(
      source.files,
      (res, item) => {
        const { Bucket, Region, Prefix } = source;
        const sourceItem = {
          Bucket,
          Region,
          Prefix,
          Key: item.key,
          isDir: item.isDir,
        };
        return res || self.isSitu(sourceItem, target);
      },
      false,
    );
  },

  // 判断 源 是否 目标 的父目录
  isParentDir(source, target) {
    return (
      source.Bucket === target.Bucket
      && source.Region === target.Region
      && source.isDir
      && target.Prefix
      && target.Prefix.indexOf(source.Key) === 0
    );
  },

  // 判断 源 是否已经在 目标的 路径下，即勾选了文件，复制，立马点击粘贴
  isSitu(source, target) {
    if (source.Bucket === target.Bucket && source.Region === target.Region) {
      const targetPrefix = target.Prefix;
      const sourceKey = source.Key;
      if (sourceKey.indexOf(targetPrefix) === 0) {
        const noPrefixKey = sourceKey.slice(targetPrefix.length);
        const dirs = noPrefixKey.split('/');
        return dirs.length <= 1 || (dirs.length === 2 && dirs[1] === '');
      }
      return false;
    }
    return false;
  },
};

const copyDirOrFileToTarget = function copyDirOrFileToTarget(opt, callback) {
  const { source, target, disabled } = opt;

  let todoCopyList = [];

  // 开始粘贴所有文件
  const paste = function paste() {
    if (!todoCopyList.length) {
      callback({ Code: 'no_file_to_paste' });
      return;
    }
    todoCopyList = todoCopyList.map(Key => {
      const url = cos.getObjectUrl({
        Bucket: source.Bucket,
        Region: source.Region,
        Key,
        Sign: false,
      });
      const targetKey = source.isDir ? target.Key + Key.substr(source.Key.length) : target.Key;
      return {
        sourceKey: Key,
        sourceLocation: url.replace(/^https?:\/\//, ''),
        targetKey,
      };
    });
    const copyResult = { successList: [], errorList: [] };
    async.eachLimit(
      todoCopyList,
      10,
      (copyItem, asyncCallback) => {
        const coptParams = {
          source: {
            Bucket: source.Bucket,
            Region: source.Region,
            Key: copyItem.sourceKey,
            Location: copyItem.sourceLocation,
          },
          target: {
            Bucket: target.Bucket,
            Region: target.Region,
            Key: copyItem.targetKey,
            Headers: copyItem.Headers || {},
          },
        };
        sliceCopyFile(
          {
            disabled,
            ...coptParams,
            onProgress(info) {
              info.Key = copyItem.targetKey;
              info.fileLoaded = copyResult.successList.length;
              info.fileTotal = todoCopyList.length;
              target.onProgress && target.onProgress(info);
            },
          },
          (err, data) => {
            const params = coptParams;

            if (err) {
              if (err.error) {
                const { error } = err;
                const statusCode = (error && error.statusCode) || err.statusCode;
                const { Code } = error;
                if (statusCode === 403 && Code === 'AccessDenied') {
                  callback(err);
                  return;
                }
              }
              params.Error = err.error || err;
              // err && console.log(err);
            }

            if (data) {
              data.metaAndAcl && (params.metaAndAcl = data.metaAndAcl);
            }

            copyResult[!err ? 'successList' : 'errorList'].push(params);
            asyncCallback();
          },
        );
      },
      () => {
        callback && callback(null, copyResult);
      },
    );
  };

  // 遍历找到所有要粘贴的文件
  if (source.isDir) {
    cos.listFiles(
      {
        Bucket: source.Bucket,
        Region: source.Region,
        Prefix: source.Key,
      },
      (err, data) => {
        if (err) {
          callback(err);
          return;
        }
        todoCopyList.push(...data.Contents.map(v => v.Key));
        paste();
      },
    );
  } else {
    todoCopyList.push(source.Key);
    paste();
  }
};

// const getRenameName = function(opt, callback) {
//   const { Key } = opt;
//   const index = Key.lastIndexOf(opt.SourceIsDir ? '/' : '.');
//   const name = index === -1 ? Key : Key.substr(0, index);
//   const ext = index === -1 ? '' : Key.substr(index);
//   const next = function(times) {
//     if (times > 100) {
//       callback({ Code: 'no_filename_available_to_paste' });
//       return;
//     }
//     const newKey = `${name} (${times})${ext}`;
//     cos.headObject(
//       {
//         Bucket: opt.Bucket,
//         Region: opt.Region,
//         Key: newKey
//       },
//       function(err, data) {
//         if (err && err.statusCode === 404) {
//           callback(null, newKey);
//         } else {
//           next(times + 1);
//         }
//       }
//     );
//   };
//   next(1);
// };

const pasteToSameDirMulti = function pasteToSameDirMulti(source, target, callback, disabled) {
  if (!source.files || !source.files.length) {
    callback({ Code: 'empty_clipboard' });
    return;
  }

  // 校验
  const errCode = checkData.isCopyForbidden({ source, target });
  if (errCode) {
    callback({ Code: errCode });
    return;
  }

  const copyResult = {
    successList: [],
    errorList: [],
  };
  async.eachLimit(
    source.files,
    5,
    (fileItem, done) => {
      const SourceKey = fileItem.key;
      let CopyTarget = target.Prefix + SourceKey.substr(source.Prefix.length);
      const getNameFinish = function getNameFinish(newKey) {
        copyDirOrFileToTarget(
          {
            source: {
              Bucket: source.Bucket,
              Region: source.Region,
              Key: SourceKey,
              isDir: fileItem.isDir,
              size: fileItem.size,
            },
            target: {
              Bucket: target.Bucket,
              Region: target.Region,
              Key: newKey,
              onProgress: target.onProgress,
            },
            disabled,
          },
          (err, data) => {
            if (err) {
              callback(err);
              return;
            }
            copyResult.successList = [...copyResult.successList, ...(data.successList || [])];
            copyResult.errorList = [...copyResult.errorList, ...(data.errorList || [])];
            done();
          },
        );
      };

      // 如果目标有自定义命名 Map，说明用户手动进行重命名
      if (target.fileNameMap && target.fileNameMap[fileItem.key]) {
        const targetKey = target.fileNameMap[fileItem.key];
        CopyTarget = target.Prefix + targetKey;
        getNameFinish(CopyTarget);
      } else if (
        target.Bucket === source.Bucket
        && target.Region === source.Region
        && target.Prefix === source.Prefix
      ) {
        callback(null, { successList: source.files });
        // getRenameName(
        //   {
        //     Bucket: target.Bucket,
        //     Region: target.Region,
        //     Key: CopyTarget,
        //     SourceIsDir: fileItem.isDir
        //   },
        //   function(err, newKey) {
        //     if (err) {
        //       copyResult.errorList.push({ SourceKey });
        //       done();
        //     } else {
        //       getNameFinish(newKey);
        //     }
        //   }
        // );
      } else {
        getNameFinish(CopyTarget);
      }
    },
    () => {
      callback(null, copyResult);
    },
  );
};

const handleError = err => {
  if (!err.error) return err.Code || err.code;

  const { error, errorAction } = err;
  let errCode = '';
  if (error.Code === 'policyFull') {
    errCode = 'up_to_1000_policy';
  } else if (error.Code === 'AccessDenied') {
    if (errorAction === 'headObject') {
      errCode = 'no_permissions_to_head_object';
    } else if (errorAction === 'getObjectAcl') {
      errCode = 'no_permissions_to_get_object_acl';
    } else if (errorAction === 'sliceCopyFile') {
      errCode = 'no_permissions_to_slice_copy_file';
    } else if (errorAction === 'getBucket') {
      errCode = 'no_permissions_to_get_bucket';
    } else {
      errCode = 'no_permissions_to_copy_file';
    }
  } else if (error.Code === 'AttachmentFull') {
    errCode = 'policies_reach_200';
  } else if (
    error.Code === 'MAZStorageClassNotSupportOnNonMAZBucket'
    || error.Code === 'OAZStorageClassNotSupportOnMAZBucket'
  ) {
    errCode = 'no_support_copy_MAZ_OAZ';
  } else {
    errCode = 'failed_to_copy_of_network';
  }
  return errCode;
};

const copyer = {
  clipboard: null,
  handleError,
  // 判断 目标 是否存在同名文件
  getSameNameList(source, target) {
    const sameNameList = [];
    return new Promise(resolve => {
      async.eachLimit(
        source.files,
        5,
        (fileItem, done) => {
          const CopyTarget = target.Prefix + fileItem.key.substr(source.Prefix.length);
          cos.headObject({ Bucket: target.Bucket, Region: target.Region, Key: CopyTarget }, (err, data) => {
            if (err) {
              if (err.statusCode === 404) {
                done();
              } else if (err.error === 'Forbidden' && err.statusCode === 403) {
                resolve({ code: 'no_permissions_to_head_object' });
              } else {
                resolve({ code: err.error });
              }
              return;
            }

            const sameNameFile = {
              name: fileItem.name,
              key: fileItem.key,
              isDir: fileItem.isDir,
              mtime: formatTime(data.headers['last-modified']),
            };
            sameNameList.push(sameNameFile);
            done();
          });
        },
        () => {
          resolve({ sameNameList });
        },
      );
    });
  },
  clear() {
    copyer.clipboard = null;
  },
  copy(source, callback) {
    copyer.clipboard = source;
    callback && callback();
  },
  async paste(target, callback) {
    const source = _.clone(copyer.clipboard);
    if (!source || !source.files) {
      callback({ Code: 'empty_clipboard' });
      return;
    }
    let disabled = '';
    if (source.files.length) {
      disabled = await checkIfHasGetObjectAcl({
        Bucket: source.Bucket,
        Region: source.Region,
        Key: source.files[0].key,
      });
    }

    if (!disabled.includes('acl')) {
      pasteToSameDirMulti(source, target, callback);
    } else {
      const action = target.action || 'copy';
      dialog.confirm(
        {
          message: lang.t('cos.confirm.paste_but_no_acl'),
          confirmText: lang.t('core.continue_param', { action: lang.t(`core.${action}`) }),
        },
        confirm => {
          if (!confirm) {
            // 取消粘贴行为
            tips.closeTips();
            return;
          }

          // 跳过 getObjectAcl 接口
          disabled = 'acl';
          pasteToSameDirMulti(source, target, callback, disabled);
        },
      );
    }
  },
  copyTo(target, callback) {
    const source = this.clipboard;
    copyer.paste(target, (err, data) => {
      tips.closeTips();

      if (err) {
        const code = handleError(err);
        if (code === 'fail') {
          tips.error(lang.t('state.fail.rename'));
        } else {
          tips.error(lang.err(`error['${code}']`, err.error ? err : ''));
        }
        callback(err);
        return;
      }
      const { errorList } = data;
      if (errorList && errorList.length > 0) {
        const closeNotification = tips.notification({
          type: 'error',
          content: h => {
            const renderFn = errorList.map(item => {
              const key = item.source.Key.substr(source.Prefix.length);
              return h('p', key);
            });
            const msg = lang.t(`state.fail.${target.action || 'copy'}_files`, {
              count: data.errorList.length,
            });
            return h('div', [
              h('p', msg),
              ...renderFn,
              h(
                'a',
                {
                  style: { cursor: 'pointer' },
                  on: {
                    click: () => {
                      closeNotification();
                      eventProxy.emit('failureTable.show', {
                        failedList: errorList.map(item => {
                          const Key = item.source.Key.substr(source.Prefix.length);
                          return { Key, Error: item.Error };
                        }),
                        type: target.action || 'copy',
                      });
                    },
                  },
                },
                lang.t('core.view'),
              ),
            ]);
          },
        });
        eventProxy.once('after-logout', () => {
          if (closeNotification) closeNotification();
        });
      }
      callback(null, data);
    });
  },
  moveTo(target, callback) {
    // 1. 源拷贝到目标
    const source = this.clipboard;
    copyer.paste(target, (err, data) => {
      tips.closeTips();

      // 移动过后不管成功与否都要清空剪辑版
      copyer.clear();

      if (err) {
        const code = handleError(err);
        tips.error(lang.err(`error['${code}']`, err.error ? err : ''));
        callback(err);
        return;
      }

      // 2. 复制成功的文件与源文件比对 header
      const errorList = data.errorList.map(item => ({ key: item.source.Key, Error: item.Error }));

      tips.loading(lang.t('core.consistency_checking'));
      checkSameMetaAndAclList(data.successList, (err1, result) => {
        tips.closeTips();
        // 3. 删除复制成功且通过一致性校验的文件
        const finalSuccessList = result.sameList.map(item => item.source);
        if (finalSuccessList.length) {
          tips.loading(lang.t('core.deleting'));
          fileDeleter(
            {
              Bucket: source.Bucket,
              Region: source.Region,
              List: finalSuccessList,
            },
            (err2, data2) => {
              const count = data2.globalSuccessCount;
              tips.loading(lang.t('core.deleting_files', { count }));
            },
            (err3, data3) => {
              tips.closeTips();
              callback(err3, data3);
            },
          );
        } else {
          // 未通过一致性校验
          callback();
        }

        // 4. 显示删除失败列表 & 未通过一致性校验的文件列表
        if (errorList && errorList.length > 0) {
          const _errorList = errorList.map(item => ({ Key: item.key.substr(source.Prefix.length), Error: item.Error }));
          const _notSameList = result.notSameList.map(item => ({
            Key: item.target.Key.substr(target.Prefix.length),
            Error: { code: 'file_consistency_check_error' },
          }));
          const closeNotification = tips.notification({
            type: 'error',
            content: h => {
              // 复制粘贴失败列表
              const renderErrorListFn = _errorList.map(({ Key }) => h('p', Key));
              const errorMsg = lang.t(`state.fail.${target.action || 'move'}_files`, {
                count: errorList.length,
              });
              // 一致性校验失败列表
              const renderCheckSameFn = _notSameList.map(({ Key }) => h('p', Key));
              const notSameMsg = lang.t('error.file_consistency_check_error_param', {
                count: _notSameList.length,
              });
              const view = () => {
                const finalErrorList = [..._errorList, ..._notSameList];
                return h(
                  'a',
                  {
                    style: { cursor: 'pointer' },
                    on: {
                      click: () => {
                        closeNotification();
                        eventProxy.emit('failureTable.show', {
                          failedList: finalErrorList,
                          type: target.action || 'move',
                        });
                      },
                    },
                  },
                  lang.t('core.view'),
                );
              };

              if (_notSameList && _notSameList.length > 0) {
                return h('div', [
                  h('p', errorMsg),
                  ...renderErrorListFn,
                  h('p', notSameMsg),
                  ...renderCheckSameFn,
                  view(),
                ]);
              }
              return h('div', [h('p', errorMsg), ...renderErrorListFn, view()]);
            },
          });
          eventProxy.once('after-logout', () => {
            if (closeNotification) closeNotification();
          });
        }
      });
    });
  },
};

export default copyer;
